// ── 입금 탭 콘텐츠 ────────────────────────────────────────────────────────────
import React from 'react';
import { FilterBar } from './FilterBar';
import {
  fmtNum, fmtDate,
  tblWrap, thStyle, tdStyle, rowCells,
  btnPrimary, btnSecondary, btnEdit, btnDanger, btnGroup,
} from './styles';

/**
 * 입금 탭 콘텐츠
 * Props:
 *   payments, filterStart, setFilterStart, filterEnd, setFilterEnd
 *   loadPayments, loadTaxInvoices
 *   setModal, handleLinkClick, linkPopup, handleDelete
 */
export function TabPayments({
  payments,
  filterStart, setFilterStart, filterEnd, setFilterEnd,
  loadPayments, loadTaxInvoices,
  setModal, handleLinkClick, linkPopup, handleDelete,
  auditTableName = 'revenue_payments', // 감사 로그 테이블명 (DOT/EXT는 다른 값 전달)
}) {
  // 기간 내 총 입금 합계
  const total = payments.reduce((s, r) => s + Number(r.amount || 0), 0);

  return (
    <>
      {/* 필터 바 + 버튼 영역 */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: 8 }}>
        <FilterBar
          filterStart={filterStart} setFilterStart={setFilterStart}
          filterEnd={filterEnd}     setFilterEnd={setFilterEnd}
          onSearch={() => { loadPayments(); loadTaxInvoices(); }}
        />
        <div style={{ display: 'flex', gap: 6 }}>
          <button style={btnPrimary}
            onClick={() => setModal({ type: 'payment', data: null })}>
            + 등록
          </button>
          <button style={btnSecondary}
            onClick={() => setModal({ type: 'auditlog', tableName: auditTableName, title: '입금' })}>
            이력
          </button>
        </div>
      </div>

      {/* 건수 / 합계 요약 */}
      <div style={{ fontSize: 12, color: 'var(--text-sub)', marginBottom: 8 }}>
        총 {payments.length}건 / 합계 <strong>{fmtNum(total)}</strong>원
      </div>

      {/* 테이블 */}
      <div style={tblWrap}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={{ ...thStyle, width: 90 }}>입금일자</th>
              <th style={thStyle}>입금자</th>
              <th style={{ ...thStyle, width: 110 }}>금액</th>
              <th style={thStyle}>마케터</th>
              <th style={{ ...thStyle, minWidth: 240 }}>세금계산서</th>
              <th style={{ ...thStyle, width: 130 }}>비고</th>
              <th style={{ ...thStyle, width: 80 }}></th>
            </tr>
          </thead>
          <tbody>
            {payments.length === 0 && (
              <tr>
                <td colSpan={7} style={{ ...tdStyle, borderBottom: 'none', textAlign: 'center', color: 'var(--text-muted)' }}>
                  데이터 없음
                </td>
              </tr>
            )}
            {payments.map((r, i) => {
              const c = rowCells(i, payments.length); // 마지막 행 밑줄 제거
              return (
              <tr key={r.id}>
                <td style={c.td}>{fmtDate(r.payment_date)}</td>
                <td style={c.td}>{r.payer_name}</td>
                <td style={c.amt}>{fmtNum(r.amount)}원</td>
                <td style={c.td}>{r.user_name || '-'}</td>

                {/* 세금계산서 연결 셀 */}
                <td style={{ ...c.td, whiteSpace: 'normal' }}>
                  {r.invoice_date ? (
                    // 연결됨: 날짜 · 상호 · 발행금액 (미입금 N원 남음)
                    <span style={{ fontSize: 11, color: '#0369a1' }}>
                      {fmtDate(r.invoice_date)} · <strong>{r.invoice_customer || '-'}</strong> · {fmtNum(r.invoice_amount)}원
                      {Number(r.invoice_unpaid) > 0 && (
                        <span style={{ marginLeft: 4, color: '#b45309', fontWeight: 600 }}>
                          ({fmtNum(r.invoice_unpaid)}원 남음)
                        </span>
                      )}
                    </span>
                  ) : (
                    // 미연결: 클릭 시 세금계산서 선택 팝업 열기
                    <button
                      onClick={(e) => handleLinkClick(e, r.id)}
                      style={{
                        fontSize: 11, padding: '2px 8px', borderRadius: 5,
                        border: '1px dashed var(--text-muted)',
                        background: linkPopup?.paymentId === r.id ? '#f0f9ff' : 'var(--bg-subtle)',
                        color: 'var(--text-muted)', cursor: 'pointer', whiteSpace: 'nowrap',
                      }}>
                      미연결
                    </button>
                  )}
                </td>

                <td style={{ ...c.td, whiteSpace: 'normal', wordBreak: 'break-word' }}>
                  {r.note || '-'}
                </td>
                <td style={c.btn}>
                  <div style={btnGroup}>
                    <button style={btnEdit}
                      onClick={() => setModal({ type: 'payment', data: r })}>수정</button>
                    <button style={btnDanger}
                      onClick={() => handleDelete('payments', r.id, '입금 내역')}>삭제</button>
                  </div>
                </td>
              </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
}
